/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ng2-toastr/src/toast-container.component';
import * as i3 from '@angular/platform-browser';
import * as i4 from 'ng2-toastr/src/toast-options';
const styles_ToastContainer:any[] = ([] as any[]);
export const RenderType_ToastContainer:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ToastContainer,data:{'animation':[{type:7,name:'inOut',definitions:[{type:0,
        name:'flyRight, flyLeft',styles:{type:6,styles:{opacity:1,transform:'translateX(0)'},
            offset:(null as any)},options:(undefined as any)},{type:0,name:'fade',
        styles:{type:6,styles:{opacity:1},offset:(null as any)},options:(undefined as any)},
        {type:0,name:'slideDown, slideUp',styles:{type:6,styles:{opacity:1,transform:'translateY(0)'},
            offset:(null as any)},options:(undefined as any)},{type:1,expr:'void => flyRight',
            animation:[{type:6,styles:{opacity:0,transform:'translateX(100%)'},offset:(null as any)},
                {type:4,styles:(null as any),timings:'0.2s ease-in'}],options:(null as any)},
        {type:1,expr:'flyRight => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateX(100%)'},offset:(null as any)},timings:'0.2s 10ms ease-out'}],
            options:(null as any)},{type:1,expr:'void => flyLeft',animation:[{type:6,
            styles:{opacity:0,transform:'translateX(-100%)'},offset:(null as any)},
            {type:4,styles:(null as any),timings:'0.2s ease-in'}],options:(null as any)},
        {type:1,expr:'flyLeft => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateX(-100%)'},offset:(null as any)},timings:'0.2s 10ms ease-out'}],
            options:(null as any)},{type:1,expr:'void => fade',animation:[{type:6,
            styles:{opacity:0},offset:(null as any)},{type:4,styles:(null as any),
            timings:'0.3s ease-in'}],options:(null as any)},{type:1,expr:'fade => void',
            animation:[{type:4,styles:{type:6,styles:{opacity:0},offset:(null as any)},
                timings:'0.3s 10ms ease-out'}],options:(null as any)},{type:1,expr:'void => slideDown',
            animation:[{type:6,styles:{opacity:0,transform:'translateY(-200%)'},offset:(null as any)},
                {type:4,styles:(null as any),timings:'0.3s ease-in'}],options:(null as any)},
        {type:1,expr:'slideDown => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateY(-200%)'},offset:(null as any)},timings:'0.3s 10ms ease-out'}],
            options:(null as any)},{type:1,expr:'void => slideUp',animation:[{type:6,
            styles:{opacity:0,transform:'translateY(200%)'},offset:(null as any)},
            {type:4,styles:(null as any),timings:'0.3s ease-in'}],options:(null as any)},
        {type:1,expr:'slideUp => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateY(200%)'},offset:(null as any)},timings:'0.3s 10ms ease-out'}],
            options:(null as any)}],options:{}}]}});
function View_ToastContainer_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'toast-close-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.removeToast((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['×\n        ']))],
      (null as any),(null as any));
}
function View_ToastContainer_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',((<any>_v.parent).context.$implicit.config.titleClass || _co.titleClass),
        '');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.title;
    _ck(_v,1,0,currVal_1);
  });
}
function View_ToastContainer_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'span',([] as any[]),
      [[8,'className',0],[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',((<any>_v.parent).context.$implicit.config.messageClass || _co.messageClass),
        '');
    const currVal_1:any = _co.sanitizer.bypassSecurityTrustHtml((<any>_v.parent).context.$implicit.message);
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_ToastContainer_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',((<any>_v.parent).context.$implicit.config.messageClass || _co.messageClass),
        '');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.message;
    _ck(_v,1,0,currVal_1);
  });
}
function View_ToastContainer_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),17,'div',([] as any[]),
      [[24,'@inOut',0],[8,'className',0]],[[(null as any),'@inOut.done'],[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('@inOut.done' === en)) {
          const pd_0:any = ((<any>_co.onAnimationEnd($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>_co.clicked(_v.context.$implicit)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastContainer_2)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),[' \n        '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastContainer_3)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),8,'div',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(16384,
          (null as any),0,i1.NgSwitch,([] as any[]),{ngSwitch:[0,'ngSwitch']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n          '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ToastContainer_4)),i0.ɵdid(278528,(null as any),
          0,i1.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,i1.NgSwitch],{ngSwitchCase:[0,
              'ngSwitchCase']},(null as any)),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastContainer_5)),
      i0.ɵdid(16384,(null as any),0,i1.NgSwitchDefault,[i0.ViewContainerRef,i0.TemplateRef,
          i1.NgSwitch],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n        '])),(_l()(),i0.ɵted((null as any),['             \n      ']))],
      (_ck,_v) => {
        const currVal_2:any = _v.context.$implicit.config.showCloseButton;
        _ck(_v,3,0,currVal_2);
        const currVal_3:any = _v.context.$implicit.title;
        _ck(_v,6,0,currVal_3);
        const currVal_4:any = _v.context.$implicit.config.enableHTML;
        _ck(_v,9,0,currVal_4);
        const currVal_5:any = true;
        _ck(_v,12,0,currVal_5);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.animate;
        const currVal_1:any = i0.ɵinlineInterpolate(1,'toast toast-',_v.context.$implicit.type,
            '');
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
export function View_ToastContainer_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,[['toastContainer',
      1]],(null as any),4,'div',[['id','toast-container']],[[4,'position',(null as any)],
      [8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ToastContainer_1)),i0.ɵdid(802816,(null as any),
          0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    var _co:i2.ToastContainer = _v.component;
    const currVal_2:any = _co.toasts;
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:i2.ToastContainer = _v.component;
    const currVal_0:any = _co.position;
    const currVal_1:any = i0.ɵinlineInterpolate(1,'',_co.positionClass,'');
    _ck(_v,1,0,currVal_0,currVal_1);
  });
}
export function View_ToastContainer_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'toast-container',
      ([] as any[]),(null as any),(null as any),(null as any),View_ToastContainer_0,
      RenderType_ToastContainer)),i0.ɵdid(180224,(null as any),0,i2.ToastContainer,
      [i3.DomSanitizer,i0.ChangeDetectorRef,i0.NgZone,i4.ToastOptions],(null as any),
      (null as any))],(null as any),(null as any));
}
export const ToastContainerNgFactory:i0.ComponentFactory<i2.ToastContainer> = i0.ɵccf('toast-container',
    i2.ToastContainer,View_ToastContainer_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9ub2RlX21vZHVsZXMvbmcyLXRvYXN0ci9zcmMvdG9hc3QtY29udGFpbmVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9ZaS1ZdS9Eb2N1bWVudHMvQWN0dWFsIERvY3VtZW50cy9LYXRpc28va2F0aXNvL25vZGVfbW9kdWxlcy9uZzItdG9hc3RyL3NyYy90b2FzdC1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9DOi9Vc2Vycy9ZaS1ZdS9Eb2N1bWVudHMvQWN0dWFsIERvY3VtZW50cy9LYXRpc28va2F0aXNvL25vZGVfbW9kdWxlcy9uZzItdG9hc3RyL3NyYy90b2FzdC1jb250YWluZXIuY29tcG9uZW50LmQudHMuVG9hc3RDb250YWluZXIuaHRtbCIsIm5nOi8vL0M6L1VzZXJzL1lpLVl1L0RvY3VtZW50cy9BY3R1YWwgRG9jdW1lbnRzL0thdGlzby9rYXRpc28vbm9kZV9tb2R1bGVzL25nMi10b2FzdHIvc3JjL3RvYXN0LWNvbnRhaW5lci5jb21wb25lbnQuZC50cy5Ub2FzdENvbnRhaW5lcl9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgI3RvYXN0Q29udGFpbmVyIGlkPVwidG9hc3QtY29udGFpbmVyXCIgW3N0eWxlLnBvc2l0aW9uXT1cInBvc2l0aW9uXCIgY2xhc3M9XCJ7e3Bvc2l0aW9uQ2xhc3N9fVwiPlxuICAgICAgPGRpdiAqbmdGb3I9XCJsZXQgdG9hc3Qgb2YgdG9hc3RzXCIgW0Bpbk91dF09XCJhbmltYXRlXCIgKEBpbk91dC5kb25lKT1cIm9uQW5pbWF0aW9uRW5kKCRldmVudClcIiBjbGFzcz1cInRvYXN0IHRvYXN0LXt7dG9hc3QudHlwZX19XCIgXG4gICAgICAoY2xpY2spPVwiY2xpY2tlZCh0b2FzdClcIj5cbiAgICAgICAgPGRpdiBjbGFzcz1cInRvYXN0LWNsb3NlLWJ1dHRvblwiICpuZ0lmPVwidG9hc3QuY29uZmlnLnNob3dDbG9zZUJ1dHRvblwiIChjbGljayk9XCJyZW1vdmVUb2FzdCh0b2FzdClcIj4mdGltZXM7XG4gICAgICAgIDwvZGl2PiBcbiAgICAgICAgPGRpdiAqbmdJZj1cInRvYXN0LnRpdGxlXCIgY2xhc3M9XCJ7e3RvYXN0LmNvbmZpZy50aXRsZUNsYXNzIHx8IHRpdGxlQ2xhc3N9fVwiPnt7dG9hc3QudGl0bGV9fTwvZGl2PlxuICAgICAgICA8ZGl2IFtuZ1N3aXRjaF09XCJ0b2FzdC5jb25maWcuZW5hYmxlSFRNTFwiPlxuICAgICAgICAgIDxzcGFuICpuZ1N3aXRjaENhc2U9XCJ0cnVlXCIgY2xhc3M9XCJ7e3RvYXN0LmNvbmZpZy5tZXNzYWdlQ2xhc3MgfHwgbWVzc2FnZUNsYXNzfX1cIiBbaW5uZXJIVE1MXT1cInNhbml0aXplci5ieXBhc3NTZWN1cml0eVRydXN0SHRtbCh0b2FzdC5tZXNzYWdlKVwiPjwvc3Bhbj5cbiAgICAgICAgICA8c3BhbiAqbmdTd2l0Y2hEZWZhdWx0IGNsYXNzPVwie3t0b2FzdC5jb25maWcubWVzc2FnZUNsYXNzIHx8IG1lc3NhZ2VDbGFzc319XCI+e3t0b2FzdC5tZXNzYWdlfX08L3NwYW4+XG4gICAgICAgIDwvZGl2PiAgICAgICAgICAgICBcbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAgICIsIjx0b2FzdC1jb250YWluZXI+PC90b2FzdC1jb250YWluZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNJUTtNQUFBO0lBQUE7SUFBQTtJQUFxRTtNQUFBO01BQUE7SUFBQTtJQUFyRTtFQUFBLGdDQUFrRzs7OztvQkFFbEc7TUFBQTtNQUEyRTs7SUFBbEQ7UUFBQTtJQUF6QixXQUF5QixTQUF6QjtJQUEyRTtJQUFBOzs7O29CQUV6RTtNQUFBO01BQUE7O0lBQTJCO1FBQUE7SUFBc0Q7SUFBakYsV0FBMkIsVUFBc0QsU0FBakY7Ozs7b0JBQ0E7TUFBQTtNQUE2RTs7SUFBdEQ7UUFBQTtJQUF2QixXQUF1QixTQUF2QjtJQUE2RTtJQUFBOzs7O29CQVBqRjtNQUFBO1VBQUE7UUFBQTtRQUFBO1FBQXFEO1VBQUE7VUFBQTtRQUFBO1FBQ3JEO1VBQUE7VUFBQTtRQUFBO1FBREE7TUFBQSxnQ0FDeUI7TUFDdkI7YUFBQTtVQUFBLHdCQUNNO01BQ047YUFBQTtVQUFBLHdCQUFnRywrQ0FDaEc7aUJBQUE7Y0FBQSxpRUFBQTtVQUFBO01BQTBDLGlEQUN4QztVQUFBLDZEQUFBO1VBQUE7Y0FBQSxnQ0FBdUo7TUFDdko7YUFBQTtxQkFBQSwrQkFBcUc7VUFBQSxpQkFDakc7O1FBTjBCO1FBQWhDLFdBQWdDLFNBQWhDO1FBRUs7UUFBTCxXQUFLLFNBQUw7UUFDSztRQUFMLFdBQUssU0FBTDtRQUNRO1FBQU4sWUFBTSxTQUFOOzs7UUFOOEI7UUFBMEQ7WUFBQTtRQUE1RixXQUFrQyxVQUEwRCxTQUE1Rjs7OztvQkFGTiwyQ0FDSTtNQUFBO01BQUE7TUFBZ0csNkNBQzlGO1VBQUEsNkRBQUE7VUFBQTtjQUFBLDJCQVNNO01BQ0Y7O0lBVkM7SUFBTCxXQUFLLFNBQUw7OztJQUR3QztJQUE0QjtJQUF0RSxXQUEwQyxVQUE0QixTQUF0RTs7OztvQkNESjtNQUFBOytCQUFBLFVBQUE7TUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/$$_gendir/node_modules/ng2-toastr/src/toast-container.component.ngfactory.ts